import { rem } from "../../components/Theme/Theme.constants.js";
import { ITheme } from "../../components/Theme/Theme.types.js";
import { SCROLLBAR_HEIGHT, SCROLLBAR_WIDTH } from "./Scrollbar.constants.js";

export const getScrollbarStyle = (theme: ITheme): string => `
    &::-webkit-scrollbar {
    background-color: ${theme.grayscale[20]};
    width: ${rem(SCROLLBAR_WIDTH)};
    height: ${rem(SCROLLBAR_HEIGHT)};
    border-radius: ${theme.radius.m};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.grayscale[70]};
    border-radius: ${theme.radius.m};
  }
`;
